import {createOrder, getOrders} from "@/api/order";

const state = {
    orderHistory: {
        data: [],
        meta: {
            current_page: 1,
            last_page: 1
        }
    }
};

const getters = {
    history: state => {
        return state.orderHistory;
    }
};

const mutations = {
    ordersListReceivedSuccess: (state, response) => {
        state.orderHistory.data.push(...response.data);
        state.orderHistory.meta = response.meta;
    },

    clearOrders: state => {
        state.orderHistory.data = [];
        state.orderHistory.meta = {
            current_page: 1,
            last_page: 1
        };
    },
};

const actions = {
    loadOrders({ commit }, page) {
        return new Promise((resolve, reject) => {
            getOrders(page)
                .then((data) => {
                    commit("ordersListReceivedSuccess", data);
                    resolve(data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },

    createNewOrder(_, data) {
        return new Promise((resolve, reject) => {
            createOrder(data).then((resp) => {
                resolve(resp);
            }).catch((error) => {
                reject(error);
            })
        });
    },

    clearOrdersData({ commit }) {
        commit("clearOrders");
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};
